import { render, staticRenderFns } from "./UserConfirmation.vue?vue&type=template&id=4e6947dc&scoped=true&"
import script from "./UserConfirmation.vue?vue&type=script&lang=js&"
export * from "./UserConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./UserConfirmation.vue?vue&type=style&index=0&id=4e6947dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6947dc",
  null
  
)

export default component.exports